// pages/ImpersonateLanding.js
//
// Kleine "bruggetje"-pagina waar een nieuw tabblad (geopend vanuit Admin.js
// z'n "Inloggen als"-knop bij een gebruiker in de Gebruikers-tab) op landt:
// leest de token/gebruiker die net van de backend kwamen (via
// POST /api/admin/impersonate/:userId) uit de querystring, bewaart die in
// sessionStorage i.p.v. het normale, tussen tabbladen GEDEELDE localStorage
// (zie utils/authSession.js - anders zou dit de echte, lopende sessie van de
// admin in diens eigen tabblad overschrijven), en stuurt dan door naar het
// juiste dashboard op basis van de rol van die gebruiker.
import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { startImpersonating } from '../utils/authSession';

function ImpersonateLanding() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const token = searchParams.get('token');
    const userJson = searchParams.get('user');

    if (!token || !userJson) {
      window.location.href = '/login';
      return;
    }

    startImpersonating(token, userJson);

    let role = null;
    try {
      role = JSON.parse(userJson).role;
    } catch (e) {
      // negeren - valt hieronder terug op /dashboard
    }

    window.location.href = role === 'SCHOONMAKER' ? '/cleaner' : '/dashboard';
  }, [searchParams]);

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#64748b',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif',
      fontSize: '15px',
    }}>
      Bezig met inloggen...
    </div>
  );
}

export default ImpersonateLanding;
